import { connect } from 'react-redux';
import { showFavouritedByModal } from '../../Modals/redux/actionCreators';
var mapDispatchToProps = {
    showFavouritedByModal: showFavouritedByModal,
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=FaveStat.container.js.map